import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/data_frames_analytics_events.py
export const DATA_FRAMES_ANALYTICS_ACTIONS = {
  EXPORTED_DATA_FRAME: {
    module: ANALYTICS_MODULE.DATA_FRAMES,
    action: 'exported_data_frame',
    actionCategory: ACTION_CATEGORY.READ,
  },
  UPDATED_DATA_FRAME_TABLE_MODE: {
    module: ANALYTICS_MODULE.DATA_FRAMES,
    action: 'updated_data_frame_table_mode',
    actionCategory: ACTION_CATEGORY.READ,
  },
  PAGINATED_DATA_FRAME_TABLE: {
    module: ANALYTICS_MODULE.DATA_FRAMES,
    action: 'paginated_data_frame_table',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SORTED_DATA_FRAME_TABLE: {
    module: ANALYTICS_MODULE.DATA_FRAMES,
    action: 'sorted_data_frame_table',
    actionCategory: ACTION_CATEGORY.READ,
  },
};
